import {AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {RSDialogComponentModel} from '../../../libs/rsnotify/rsdialog.component.model';
import {ExtensionActivityType, ExtensionCategory} from '../../../../functions/src/types';
import {RSDialog} from '../../../libs/rsnotify/rsdialog';
import {UserService} from "../../services/user.service";
import {RSValidatorFormDirective} from "../../../libs/rsvalidator/rsvalidator.directive";
import {AvailableIcon, IconsService} from "../../services/icons.service";
import {DataService} from "../../services/data.service";
import invert from "invert-color";
import {ReplaySubject} from "rxjs";
import {map} from "rxjs/operators";

@Component({
  selector: 'app-add-activity',
  templateUrl: './add-activity.component.html',
  styleUrls: ['./add-activity.component.scss']
})
export class AddActivityComponent extends RSDialogComponentModel implements OnInit, AfterViewInit, OnDestroy {
  activity: ExtensionActivityType = {} as ExtensionActivityType;
  @ViewChild('actionButtons', {static: true, read: TemplateRef}) actionButtons: TemplateRef<any>;
  @ViewChild('form') inputForm: RSValidatorFormDirective;

  filteredCategories = new ReplaySubject<ExtensionCategory[]>(1);


  constructor(private userService: UserService, public dataService: DataService) {
    super();

    // Wait for input
    this.dialogValuesUpdated.subscribe(v => {
      this.updateActivity(v.activity);
    });
    this.updateActivity({});
  }

  invertColor(hex) {
    return invert(hex || '#ffffff', true);
  }

  ngOnInit(): void {
    this.dataService.categories.pipe(
      map(categories => {
        // Get all non-archived categories
        const activeCategories = categories.filter(cat => !cat.archived);

        // If we have a selected category that's archived, add it to the list
        if (this.activity.category) {
          const selectedCategory = categories.find(cat =>
            cat.id === this.activity.category && cat.archived);
          if (selectedCategory) {
            activeCategories.push(selectedCategory);
          }
        }

        return activeCategories;
      })
    ).subscribe(filtered => {
      this.filteredCategories.next(filtered);
    });


  }

  ngOnDestroy() {
    this.filteredCategories.complete();
  }

  ngAfterViewInit(): void {
    this.dialogHandles.buttonTemplateRef = this.actionButtons;
    this.dialogHandles.buttonTemplateAttach();
  }

  updateActivity(input: any) {
    this.activity = {
      id: input.id || null,
      name: input.name || null,
      category: input.category || null,
      archived: input.archived || false,
    } as ExtensionActivityType;
    console.log('AddCategoryComponent::: ', this.activity);
  }

  close() {
    this.dialogHandles.close(RSDialog.defaultValues.CANCEL);
  }

  saveCategory() {
    if (!this.inputForm.isValid(true)) {
      return;
    } else {
      this.dialogValues.activity = this.activity;
      this.dialogHandles.close(RSDialog.defaultValues.YES);
    }
  }

}
